import { connect } from 'react-redux';
import { push } from 'connected-react-router'
import { useEffect, useState } from 'react'
import { setAgencyBusinessContact } from '../../redux/slice/primaryAgencyApplicationSlice'
import {
    businessContactDetailSelect,
    populateBusinessContactDetailsForReview
} from '../../redux/selector/businessContactDetailSelector'
import TopNavigationBar from '../TopNavigationBar'
import ContactDetailsInputForm from '../../components/ContactDetails/ContactDetailsInputForm'
import CheckBoxForm from '../../components/CheckBoxForm'
import {
    Header, 
    Paragraph, 
    Button,
    NavigationLinkButton,
    ErrorMark,
    LineSeperator
} from '../../components/RegularComponents'
import ReviewForm from '../../components/ReviewForm/ReviewForm'
import {
    APPLICATION_MODE_RENEW,
    VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT,
    VIEW_MODE_REGULAR,
    VIEW_MODE_RENEWAL_EDIT,
    VIEW_MODE_RENEWAL_PREVIEW
} from '../../app/constants'
import { areContactObjectSame, replaceUrlParams, ValidateString } from '../../app/utils';
import Navigation from '../Navigation';
import { saveBusinessLicenceApplicationData } from '../../redux/slice/businessLicenceApplicationSlice';
import { ERROR_STRING, VALIDATION_ERROR, VALIDATION_TYPE } from '../../app/errors';

/*
 * This is the actual component rendered
 * applicationType : business_licence, debt_management
 * applicationMode : 
 *    - renewal
        - renewalEdit
        - renewalPreview
 *    - new
 *
 * viewMode options :
 *  - nothing set : undefined (regular)
 *  - regular : regular
 *  - editReview : showing up in the edit mode popup
 */ 

//  const BusinessLicenceViewModeSelector = (props) => {
//     const {applicationType, applicationMode} = props.match.params

//     const [viewMode,setViewMode] = useState(props.viewMode ? 
//         props.viewMode : (applicationMode === APPLICATION_MODE_RENEW ? VIEW_MODE_RENEWAL_PREVIEW : VIEW_MODE_REGULAR))

//     return (
//         <div>
//             {props.children}
//         </div>
//     )        
//  }

const BusinessContactDetail = (props) => {
    const {businessContactDetail} = props
    const {applicationType, applicationMode} = props.match.params
    
    const [viewMode,setViewMode] = useState(props.viewMode ? 
                props.viewMode : (applicationMode === APPLICATION_MODE_RENEW ? VIEW_MODE_RENEWAL_PREVIEW : VIEW_MODE_REGULAR)) 

    const defaultContact = () => ({
        firstName : "",
        lastName : "",
        phoneNumber:"",
        emailAddress:""
    })

    const [businessContactData, setBusinessContactData] = useState(businessContactDetail.mainBusinessContact 
                                                                    ? businessContactDetail.mainBusinessContact 
                                                                    : defaultContact())
    const [complianceContactData, setComplianceContactData] = useState(businessContactDetail.complianceOfficer 
                                                                    ? businessContactDetail.complianceOfficer 
                                                                    : defaultContact())
    const [responsibleAgentData, setResponsibleAgentData] = useState(businessContactDetail.responsibleAgent 
                                                                    ? businessContactDetail.responsibleAgent 
                                                                    : defaultContact())                                                                    
    
    const [applicationSaveError, setApplicationSaveError] = useState(false)

    let complianceIsSame = false                                                                
    if(businessContactDetail.mainBusinessContact && businessContactDetail.complianceOfficer) {
        complianceIsSame = areContactObjectSame(businessContactDetail.mainBusinessContact, businessContactDetail.complianceOfficer)
    }                                                                

    const [complianceSameAsMainBusinessCheckbox,setComplianceSameAsMainBusinessCheckbox] = useState(complianceIsSame)

    let responsibleAgentIsSame = false                                                                
    if(businessContactDetail.mainBusinessContact && businessContactDetail.responsibleAgent) {
        responsibleAgentIsSame = areContactObjectSame(businessContactDetail.mainBusinessContact, businessContactDetail.responsibleAgent)
    }

    const [responsibleAgentSameAsMainBusinessCheckbox,setResponsibleAgentSameAsMainBusinessCheckbox] = useState(responsibleAgentIsSame)
    const [showValidationError, setShowValidationError] = useState(false)

    const onBusinessContactChange = (updatedDetail) => {
        let updateContactDetails = Object.assign({}, businessContactData, updatedDetail)
        setBusinessContactData(updateContactDetails)
    }

    const onComplianceContactChange = (updatedDetail) => {
        let updateComplianceDetails = Object.assign({},complianceContactData, updatedDetail)
        setComplianceContactData(updateComplianceDetails)
    }

    const onResponsibleAgentChange = (updatedDetail) => {
        let updateAgent = Object.assign({}, responsibleAgentData, updatedDetail)
        setResponsibleAgentData(updateAgent)
    }

    const onComplianceCheckBoxChange = (value) => {
        setComplianceSameAsMainBusinessCheckbox(value)
        // this means, the compliance office is different
        if(!value) {
            setComplianceContactData(defaultContact())
        } else { 
            setComplianceContactData(Object.assign({}, businessContactData))
        }
    }

    const onResponsibleAgentCheckBoxChange = (value) => { 
        setResponsibleAgentSameAsMainBusinessCheckbox(value)
        // this means, the responsible agent is different
        if(!value) {
            setResponsibleAgentData(defaultContact())
        } else { 
            setResponsibleAgentData(Object.assign({}, businessContactData))
        }
    }

    const saveData = () => {
        let update = {
            mainBusinessContact : businessContactData
        }

        if(complianceSameAsMainBusinessCheckbox) {
            Object.assign(update, {complianceOfficer : businessContactData})
        } else { 
            Object.assign(update, {complianceOfficer : complianceContactData})
        }

        if(responsibleAgentSameAsMainBusinessCheckbox) { 
            Object.assign(update, {responsibleAgent : businessContactData})
        } else { 
            Object.assign(update, {responsibleAgent : responsibleAgentData})
        }

        props.dispatch(setAgencyBusinessContact(update))
    }

    const validateData = () => { 

        //businessContactData
        if (ValidateString(businessContactData.firstName, VALIDATION_TYPE.NAME) !== VALIDATION_ERROR.NO_ERROR)
            return false
        else if(ValidateString(businessContactData.lastName, VALIDATION_TYPE.NAME) !== VALIDATION_ERROR.NO_ERROR)
            return false
        else if(ValidateString(businessContactData.phoneNumber, VALIDATION_TYPE.PHONE_NUMBER) !== VALIDATION_ERROR.NO_ERROR)
            return false
        else if(ValidateString(businessContactData.emailAddress, VALIDATION_TYPE.EMAIL) !== VALIDATION_ERROR.NO_ERROR)
            return false
            
        if(!complianceSameAsMainBusinessCheckbox) {
            if (ValidateString(complianceContactData.firstName, VALIDATION_TYPE.NAME) !== VALIDATION_ERROR.NO_ERROR)
                return false
            else if(ValidateString(complianceContactData.lastName, VALIDATION_TYPE.NAME) !== VALIDATION_ERROR.NO_ERROR)
                return false
            else if(ValidateString(complianceContactData.phoneNumber, VALIDATION_TYPE.PHONE_NUMBER) !== VALIDATION_ERROR.NO_ERROR)
                return false
            else if(ValidateString(complianceContactData.emailAddress, VALIDATION_TYPE.EMAIL) !== VALIDATION_ERROR.NO_ERROR)
                return false
        }

        if(!responsibleAgentSameAsMainBusinessCheckbox) { 
            if (ValidateString(responsibleAgentData.firstName, VALIDATION_TYPE.NAME) !== VALIDATION_ERROR.NO_ERROR)
                return false
            else if(ValidateString(responsibleAgentData.lastName, VALIDATION_TYPE.NAME) !== VALIDATION_ERROR.NO_ERROR)
                return false
            else if(ValidateString(responsibleAgentData.phoneNumber, VALIDATION_TYPE.PHONE_NUMBER) !== VALIDATION_ERROR.NO_ERROR)
                return false
            else if(ValidateString(responsibleAgentData.emailAddress, VALIDATION_TYPE.EMAIL) !== VALIDATION_ERROR.NO_ERROR)
                return false
        }

        return true
    }

    const onSaveAndNextClick = () => {

        if(!validateData()) { 
            setShowValidationError(true)
            return
        }

        setShowValidationError(false)

        saveData()

        props.dispatch(saveBusinessLicenceApplicationData(applicationType, applicationMode))
            .then((data) => {
                props.dispatch(push(replaceUrlParams(businessContactDetail.navigation.next,applicationType, applicationMode)))
            })
            .catch((error) => {
                setApplicationSaveError(true)
            })
    }

    const onEditModeSaveClick = () => {

        if(!validateData()) { 
            setShowValidationError(true)
            return
        }
        
        setShowValidationError(false)

        saveData()
        if(props.onEditSave)
            props.onEditSave()
    }

    useEffect(() => { 
        setBusinessContactData(businessContactDetail.mainBusinessContact)
        setComplianceContactData(businessContactDetail.complianceOfficer)
        setResponsibleAgentData(businessContactDetail.responsibleAgent)

        let complianceIsSame = false                                                                
        if(businessContactDetail.mainBusinessContact && businessContactDetail.complianceOfficer) {
            complianceIsSame = areContactObjectSame(businessContactDetail.mainBusinessContact, businessContactDetail.complianceOfficer)
        } 
        setComplianceSameAsMainBusinessCheckbox(complianceIsSame)

        let responsibleAgentIsSame = false 
        if(businessContactDetail.mainBusinessContact && businessContactDetail.responsibleAgent) {
            responsibleAgentIsSame = areContactObjectSame(businessContactDetail.mainBusinessContact, businessContactDetail.responsibleAgent)
        } 
        setResponsibleAgentSameAsMainBusinessCheckbox(responsibleAgentIsSame)
    }, [
        businessContactDetail, 
        setBusinessContactData, 
        setComplianceContactData,
        setResponsibleAgentData,
        setComplianceSameAsMainBusinessCheckbox,
        setResponsibleAgentSameAsMainBusinessCheckbox
    ])

    return (
        <>
            {viewMode !== VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT && 
            <Navigation {...props} /> }
            <div className={viewMode !== VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT ? "container" : ""}>
            {viewMode !== VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT && 
            <>
                <TopNavigationBar {...props}/>
                <div className="row">
                    <div className="col-lg-8">
                        <Header header={viewMode === VIEW_MODE_RENEWAL_PREVIEW
                                ? businessContactDetail.headerRenewal : businessContactDetail.header} />
                        <Paragraph text={viewMode === VIEW_MODE_RENEWAL_PREVIEW
                            ? businessContactDetail.textRenewal : businessContactDetail.text} />
                    </div>
                </div>
            </>
            }
            <div className="row bottomMarginMedium">
                <div className="col-lg-10">
                    <h2>Business contact for licensing inquiries</h2>
                    <LineSeperator style={{marginTop: "0px"}} />
                    {viewMode === VIEW_MODE_RENEWAL_PREVIEW && 
                        <>
                            <ReviewForm data={populateBusinessContactDetailsForReview(businessContactData)}/>
                            
                            <div>
                                <h2>Business contact for consumer complaints and compliance</h2>
                                <LineSeperator style={{marginTop: '0px'}} />
                            </div>

                            <ReviewForm data={populateBusinessContactDetailsForReview(complianceContactData)}/>
                        </>
                    }
                    {viewMode !== VIEW_MODE_RENEWAL_PREVIEW && 
                        <>
                            <ContactDetailsInputForm 
                                id={"business-contact"} 
                                onInputChange={onBusinessContactChange} 
                                preloadInput={businessContactData} 
                                showValidationError={showValidationError}
                            />
                            
                            <div>
                                <h2>Business contact for consumer complaints and compliance</h2>
                                <LineSeperator style={{marginTop: "0px"}} />
                            </div>
                            
                            <div style={{margin : "20px 10px"}}>
                                <CheckBoxForm
                                    id = {"business-contact-checkbox"}
                                    value={"business-compliance-same"}
                                    labelText={"Same as contact for licensing inquiries"}
                                    onCheckBoxChange={onComplianceCheckBoxChange} 
                                    checked={complianceSameAsMainBusinessCheckbox}
                                />
                            </div>
                            {!complianceSameAsMainBusinessCheckbox && <div style={{margin : "30px"}}>
                                <ContactDetailsInputForm 
                                    id={"compliance-contact"}
                                    onInputChange={onComplianceContactChange} 
                                    preloadInput={complianceContactData} 
                                    showValidationError={showValidationError}    
                                />
                            </div>}

                            <div>
                                <h2>Responsible agent</h2>
                                <LineSeperator style={{marginTop: "0px"}} />
                            </div>
                            
                            <div style={{margin : "20px 10px"}}>
                                <CheckBoxForm
                                    id = {"responsible-agent-same-as-main-contact-checkbox"}
                                    value={"responsible-agent-same-as-main-contact"}
                                    labelText={"Same as contact for licensing inquiries"}
                                    onCheckBoxChange={onResponsibleAgentCheckBoxChange} 
                                    checked={responsibleAgentSameAsMainBusinessCheckbox}
                                />
                            </div>
                            {!responsibleAgentSameAsMainBusinessCheckbox && <div style={{margin : "30px"}}>
                                <ContactDetailsInputForm 
                                    id={"responsible-agent"}
                                    onInputChange={onResponsibleAgentChange} 
                                    preloadInput={responsibleAgentData} 
                                    showValidationError={showValidationError}    
                                />
                            </div>}
                        </>
                    }
                </div>
            </div>
            <div className="row bottomMarginMedium">
                {viewMode === VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT && 
                    <div className={"col-lg-10" + (applicationSaveError ? " has-error" : "")}>
                        <Button 
                            id={"business-contact-save-next"}
                            text={"Save"}
                            onClick={onEditModeSaveClick}
                            buttonType={"regular_primary"}
                        />
                        {applicationSaveError && ErrorMark()}
                        {applicationSaveError && 
                        <div className="ns-error-message help-block">
                            <span className="ns-visually-hidden">Error:</span>
                            {ERROR_STRING.APPLICATION_SAVE_ERROR}
                        </div>}
                    </div>
                }
                {viewMode !== VIEW_MODE_EDIT_PREVIEW_BEFORE_SUBMIT &&
                <> 
                    <div className={"col-lg-4" + (applicationSaveError ? " has-error" : "")}>
                        <Button 
                            id={"business-contact-save-next"}
                            text={"Save and next"}
                            onClick={onSaveAndNextClick}
                            buttonType={"regular_primary"}
                        />
                        {applicationSaveError && ErrorMark()}
                        {applicationSaveError && 
                        <div className="ns-error-message help-block topMarginNormal">
                            <span className="ns-visually-hidden">Error:</span>
                            {ERROR_STRING.APPLICATION_SAVE_ERROR}
                        </div>}
                    </div>
                    {viewMode === VIEW_MODE_RENEWAL_PREVIEW && 
                    <div className="col-lg-4">
                        <NavigationLinkButton 
                            id={"business-contact-edit-mode-switch"}
                            text={"Update this information before continuing"}
                            onClick={() => { setViewMode(VIEW_MODE_RENEWAL_EDIT)}}
                        />
                    </div>}
                </>
                }
            </div>
        </div>
        </>
    )
}

export default connect(businessContactDetailSelect) (BusinessContactDetail)
